import { useState } from 'react';
import { Row, Col } from 'antd';
import { AdminMenuLayout } from '../../../shared/components';
import { ConversationsList } from './ConversationsList';
import { ChatWindow } from './ChatWindow';
import styled from 'styled-components';

const Container = styled.div`
  height: calc(100vh - 112px);
  max-height: calc(100vh - 112px);
  overflow: hidden;
`;

export const Messages = () => {
  const [selectedUserId, setSelectedUserId] = useState<number | undefined>();
  const [selectedUserName, setSelectedUserName] = useState<string>('');

  const handleSelectUser = (userId: number, userName?: string) => {
    setSelectedUserId(userId);
    setSelectedUserName(userName || `Usuario ${userId}`);
  };

  return (
    <AdminMenuLayout pageDescription="Mensajes" title="Chat con Clientes">
      <style>{`
        .site-layout-background {
          overflow: hidden !important;
          padding: 16px !important;
        }
      `}</style>
      <Container>
        <Row gutter={16} style={{ height: '100%' }}>
          <Col span={8} style={{ height: '100%' }}>
            <ConversationsList
              selectedUserId={selectedUserId}
              onSelectUser={handleSelectUser}
            />
          </Col>
          <Col span={16} style={{ height: '100%' }}>
            <ChatWindow
              userId={selectedUserId || 0}
              userName={selectedUserName || 'Cliente'}
            />
          </Col>
        </Row>
      </Container>
    </AdminMenuLayout>
  );
};
